export default __webpack_public_path__ + "f2a20a50b205e223c549458a74da160e.svg";